import ITimeZone from '@/types/ITimeZone';
import { Box } from '@chakra-ui/react';
import TimeZoneSelector from './components/time-zone-selector.view';

interface IProps {
	timeZone: ITimeZone;
	onTimezoneChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export default function BookingPageFooter(props: IProps) {
	return (
		<Box display="grid" gridTemplateColumns="1fr" p={4} alignItems="center">
			<TimeZoneSelector value={props.timeZone} onChange={props.onTimezoneChange} />
		</Box>
	);
}
